export { default as CNComp } from './CNComp';
export { default as MCNComp } from './MCNComp';
export { default as MMSComp } from './MMSComp';
export { default as NotiPrivacyTransferComp } from './NotiPrivacyTransferComp';
export { default as HomePrivacyPopup } from './HomePrivacyPopup';